import React from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import ImageUploadPreview from '../../../../components/ImageUploadPreview';
import { CloseIcon, DocIcon } from '../../../../components/Icon';
import { onKeyUpEnterOrSpace, isImageFile, getArrayRandomKey } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  foot: {
    padding: '1rem 0 2.813rem',
    margin: '0 1.875rem -0.0625rem',
    borderTop: '0.0625rem solid #ddd',
    display: 'flex',
    flexWrap: 'wrap',
    gridGap: '0.938rem',
  },
  img: {
    minWidth: '16.563rem',
    // height: '3.125rem',
    borderRadius: '1.142rem',
    backgroundColor: ' #f5faff',
    color: theme.palette.font.main,
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    // marginRight: '0.938rem',
    justifyContent: 'space-between',
    // marginTop: '0.875rem',
    padding: '1.142rem 0',
  },
  file: {
    width: '1rem',
    height: '1.25rem',
    color: theme.palette.primary.main,
  },
  box: {
    width: '1.875rem',
    height: '1.875rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  close: {
    width: '1rem',
    height: '1rem',
    color: theme.palette.primary.main,
  },
  loading: {
    color: theme.palette.primary.main,
  },
  closebox: {
    width: '1.875rem',
    height: '1.875rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 0.938rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export default function ShowSelectedFiles({
  photo,
  files,
  setPhoto,
  setFiles,
  otherFile = [],
  handleDeleteOtherFile = null,
  handleDeletePhoto = null,
  handleDeleteFile = null,
}) {
  const classes = useStyles();

  const Imger = ({ name, index, data, setData, itemId = '', handleRemove = null, uploading = false }) => {
    const classes = useStyles();

    const handleOnClick = async () => {
      if (uploading) {
        return;
      }
      if (handleDeleteOtherFile && _.isFunction(handleDeleteOtherFile) && itemId) {
        handleDeleteOtherFile(itemId);
        return;
      }
      if (_.isFunction(handleRemove)) {
        await handleRemove();
        return;
      }
      setData([...data.slice(0, index), ...data.slice(index + 1)]);
    };

    return (
      <div className={classes.img}>
        <div style={{ display: 'flex', alignItems: 'center', height: '2.5rem' }}>
          <div className={classes.box} style={{ margin: '0 0.625rem' }}>
            <DocIcon className={classes.file} />
          </div>
          {name}
        </div>
        <div
          className={classes.closebox}
          onClick={handleOnClick}
          tabIndex={uploading ? -1 : 0}
          onKeyUp={(e) => !uploading && onKeyUpEnterOrSpace(e, handleOnClick)}
        >
          {uploading ? <CircularProgress size={18} className={classes.loading} /> : <CloseIcon className={classes.close} />}
        </div>
      </div>
    );
  };

  return (
    (photo.length > 0 || files.length > 0 || otherFile.length > 0) && (
      <div className={classes.foot}>
        {otherFile.length > 0 &&
          otherFile.map((item, index) => {
            return isImageFile(item?.name) && item?.previewUrl ? (
              <ImageUploadPreview
                name={item.name}
                previewUrl={item?.previewUrl}
                key={getArrayRandomKey(`${item.id}-${index}`, 'upload-img')}
                index={index}
                data={otherFile}
                handleRemove={() => handleDeleteOtherFile(item?.id)}
              />
            ) : (
              <Imger name={item.name} key={item.id} index={index} data={otherFile} itemId={item.id} />
            );
          })}

        {photo.length > 0 &&
          photo.map((item, index) => (
            <ImageUploadPreview
              name={item.name}
              previewUrl={item?.previewUrl}
              key={getArrayRandomKey(`${item.name}-${index}`, 'upload-img')}
              index={index}
              data={photo}
              uploading={Boolean(item?.uploading)}
              setData={setPhoto}
              handleRemove={_.isFunction(handleDeletePhoto) ? async () => handleDeletePhoto(item, index) : null}
            />
          ))}

        {files.length > 0 &&
          files.map((item, index) => {
            return item?.previewUrl ? (
              <ImageUploadPreview
                name={item.name}
                previewUrl={item?.previewUrl}
                key={getArrayRandomKey(`${item.name}-${index}`, 'upload-file-img')}
                index={index}
                data={files}
                uploading={Boolean(item?.uploading)}
                setData={setFiles}
                handleRemove={_.isFunction(handleDeleteFile) ? async () => handleDeleteFile(item, index) : null}
              />
            ) : (
              <Imger
                name={item.name}
                key={getArrayRandomKey(`${item.name}-${index}`, 'upload-file')}
                index={index}
                data={files}
                setData={setFiles}
                uploading={Boolean(item?.uploading)}
                handleRemove={_.isFunction(handleDeleteFile) ? async () => handleDeleteFile(item, index) : null}
              />
            );
          })}
      </div>
    )
  );
}
